import { useState } from "react";
import { Button, Form, Input, notification, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { post } from "../../services";

const EventForm = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  // notification handler
  const openNotification = (message, description) => {
    notification.open({
      message: message,
      description: description,
    });
  };

  // onFinish handler
  const onFinish = (values) => {
    setLoader(true);
    post(`/auth/register`, values)
      .then(() => {
        setLoader(false);
        navigate("/");
        openNotification("Success", "Admin created Successfully");
      })
      .catch(() => {
        setLoader(false);
        openNotification("Error", "");
      });
  };

  return (
    <>
      <div className="header">
        <h3>Add User</h3>
      </div>
      <div className="form_container">
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: "Please enter your Name" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, message: "Please enter your Email" }]}
          >
            <Input type="email" />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: "Please enter your Password" }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="role"
            label="Role"
            rules={[{ required: true, message: "Please select yout Time" }]}
          >
            <Select
              options={[
                { value: "", label: "Select Role" },
                {
                  value: "admin",
                  label: "Admin",
                },
                {
                  value: "sales",
                  label: "Sales",
                },
                {
                  value: "onboarding",
                  label: "On Boarding",
                },
                {
                  value: "operations",
                  label: "Operations",
                },
                {
                  value: "hr",
                  label: "Hr",
                },
                {
                  value: "accounts",
                  label: "Accounts",
                },
                {
                  value: "inventory",
                  label: "Inventory",
                },
                {
                  value: "property_management",
                  label: "Property Management",
                },
              ]}
            />
          </Form.Item>
          <Form.Item>
            <div className="form_submit">
              <Button className="back_button" onClick={() => navigate("/")}>
                Back
              </Button>
              <Button htmlType="submit">{loader ? "wait..." : "Save"}</Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};
export default EventForm;
